import type { ChampionshipStatisticsOutput } from '@schemas'
import { DataTable } from '@/features/show-release/HighlightsTables'

export function ChampionshipStatesTable({
  data,
}: {
  data: Pick<ChampionshipStatisticsOutput, 'states' | 'unlocated'>
}) {
  return (
    <DataTable
      visibleCaption
      caption="Entrants and awards by home state"
      headers={['Home state', 'Entrants', 'Exhibits', 'Ribbons', 'First places']}
      rows={[
        ...data.states.map(row => [
          row.state,
          row.entrants,
          row.entries,
          row.ribbons,
          row.firstPlaces,
        ]),
        [
          'State not recorded',
          data.unlocated.entrants,
          data.unlocated.entries,
          data.unlocated.ribbons,
          data.unlocated.firstPlaces,
        ],
      ]}
    />
  )
}
export function ChampionshipRegionsTable({ data }: { data: ChampionshipStatisticsOutput }) {
  return (
    <DataTable
      visibleCaption
      caption="Extracted honey exhibits by home region"
      headers={['Home region', 'Light', 'Amber', 'Dark']}
      rows={data.regions.map(row => [
        row.region ?? 'State not recorded',
        ...[row.light, row.amber, row.dark].map(value =>
          value === null ? 'Unavailable: no class identified' : value
        ),
      ])}
    />
  )
}
export function ChampionshipReview({ data }: { data: ChampionshipStatisticsOutput }) {
  const recorded = data.states.reduce((sum, row) => sum + row.entrants, 0)
  return (
    <section aria-label="Championship figures to release" className="space-y-3">
      <p className="font-medium">Championship series: {data.series.name}</p>
      <p>
        Home state recorded: {recorded} of {recorded + data.unlocated.entrants} entrants.
      </p>
      <p className="text-sm text-muted-foreground">
        Missing or unrecognized states do not block release. Administrators can correct Person home
        states before a fresh review. Exact state counts, including single entrants, will be public.
        Ribbons count class placements; special awards are excluded.
      </p>
      <ChampionshipStatesTable data={data} />
      <ChampionshipRegionsTable data={data} />
    </section>
  )
}
